import { combineReducers } from 'redux';
import loader, { defaultLanguage, otherLanguage } from './common';

const rootReducer = combineReducers({
  loader,
  defaultLanguage,
  otherLanguage
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js